const colorSwatches = document.querySelectorAll('[data-color-swatch]');
const sectionId = document.querySelector("[data-mineral-wall-stain-section-id]").value;

colorSwatches.forEach(colorSwatch => {
  colorSwatch.addEventListener('click', (e) => {
    e.preventDefault();

    colorSwatches.forEach(swatch => swatch.classList.remove('is-selected'));

    e.target.classList.add('is-selected');

    document.documentElement.dispatchEvent(
      new CustomEvent("theme:loading:start", { bubbles: true })
    );

    fetch(e.target.href + `?sections=${sectionId}`)
    .then((response) => response.json())
    .then((response) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(response[sectionId], "text/html");

      const DOMArray = [
        "[data-block-type='title']",
        "[data-block-type='buy-buttons']",
        "[data-block-type='price']",
        "[data-block-type='quantity-selector']",
        "[data-block-type='variant-picker']",
        "product-gallery",
      ];

      DOMArray.forEach((DOM) => {
        if (doc.querySelector(DOM)) {
          document.querySelector(DOM).outerHTML = doc.querySelector(DOM).outerHTML;
        }
      });

      document.documentElement.dispatchEvent(
        new CustomEvent("theme:loading:end", { bubbles: true })
      );
    });
  });
})